/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TimePeriodServiceGetResponse
 */
export interface TimePeriodServiceGetResponse {
    /**
     * 
     * @type {Date}
     * @memberof TimePeriodServiceGetResponse
     */
    timePeriodDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof TimePeriodServiceGetResponse
     */
    createdBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TimePeriodServiceGetResponse
     */
    createdDate?: Date;
}

/**
 * Check if a given object implements the TimePeriodServiceGetResponse interface.
 */
export function instanceOfTimePeriodServiceGetResponse(value: object): value is TimePeriodServiceGetResponse {
    return true;
}

export function TimePeriodServiceGetResponseFromJSON(json: any): TimePeriodServiceGetResponse {
    return TimePeriodServiceGetResponseFromJSONTyped(json, false);
}

export function TimePeriodServiceGetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimePeriodServiceGetResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'timePeriodDate': json['timePeriodDate'] == null ? undefined : (new Date(json['timePeriodDate'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
    };
}

export function TimePeriodServiceGetResponseToJSON(json: any): TimePeriodServiceGetResponse {
    return TimePeriodServiceGetResponseToJSONTyped(json, false);
}

export function TimePeriodServiceGetResponseToJSONTyped(value?: TimePeriodServiceGetResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timePeriodDate': value['timePeriodDate'] == null ? undefined : ((value['timePeriodDate']).toISOString()),
        'createdBy': value['createdBy'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
    };
}

